import React from 'react';
import { TransformCta } from '../TransformCta';
import { IMAGES } from '../../lib/constants';
export function About() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-61" data-mp="oqm6hu2xedjm">
      <div className="mx-auto max-w-2xl" data-id="element-62" data-mp="12rf26i4yreob">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-gold-600" data-id="element-63" data-mp="12qdijp9vtjuz">
          Sobre la autora
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-64" data-mp="azqvoc8v9mde">
          Sobre la Dra. Karito
        </h2>

        <div className="mt-7 overflow-hidden rounded-3xl border border-navy-100 bg-white shadow-card" data-id="element-65" data-mp="5yjnwd6q4n6q">
          <img src={IMAGES.drKarito} alt="Dra. Karito, creadora del Sistema de Diagnóstico Facial" className="h-64 w-full object-cover object-top sm:h-80" loading="lazy" data-id="element-66" data-mp="jtvrzb6rrq0b" />
          <div className="space-y-3 p-5 text-[14.5px] leading-relaxed text-navy-600 sm:p-7 sm:text-base" data-id="element-67" data-mp="3jg2f26kd8abc">
            <p data-id="element-68" data-mp="33a0b1h9bfus7">
              Durante años observamos que muchos ortodoncistas compartían el mismo problema. No era
              la falta de conocimientos. Era la falta de un proceso claro para transformar toda la
              información clínica en una decisión segura.
            </p>
            <p className="font-semibold text-navy-900" data-id="element-69" data-mp="3hyo2pcg1jkcv">
              De ahí nació el Sistema de Diagnóstico Facial.
            </p>
            <p data-id="element-70" data-mp="2kbnz5nr0s6sx">
              Una metodología creada para ayudar a los profesionales hispanohablantes a evaluar cada
              paciente con un orden lógico, integrar el análisis facial con la cefalometría y reducir
              la incertidumbre antes de iniciar cualquier tratamiento.
            </p>
            <p data-id="element-71" data-mp="2z980mkopjjuc">
              Porque cuando el diagnóstico mejora, también mejoran las decisiones, la confianza del
              profesional y la experiencia del paciente.
            </p>
          </div>
        </div>

        <TransformCta headline="Adopta la metodología completa en tu propia consulta." label="Quiero acceder al sistema" location="sobre" data-id="element-72" data-mp="ejincc3nk63r" />
      </div>
    </section>;
}